<template>
  <div>
    <p class="mb-3" v-html="$sanitize(payload.content)"></p>
    <a @click="openInternalNotes" class="button is-outlined is-info">Create new resource</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'FeedContentFindNewCompanues',
  props: {
    payload: {
      type: Object
    }
  },
  methods: {
    openInternalNotes () {
      this.create({
        designator: 'create-company-step-one',
        component_name: 'CreateCompanyStepOne',
        ignore_escape_button: true,
        modal_title: 'Create new Company'
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
